import { Flex, Text, Avatar } from '@chakra-ui/react';

type Props = {
  avatar: string;
  quote: string;
  name: string;
  company: string;
};

const SocialQuote = ({ avatar, company, name, quote }: Props) => (
  <Flex align="start" justify="start" direction="row">
    <Avatar me={9} name={name} src={avatar} />
    <Flex direction="column">
      <Text fontSize="sm" lineHeight={2}>
        “{quote}”
      </Text>
      <Text mt={10}>
        <strong>{name},</strong>
        {company}
      </Text>
    </Flex>
  </Flex>
);

export default SocialQuote;
